var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Positive_affirmative_notification",
    "data-name": "Positive, affirmative notification",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3239",
    "data-name": "Ellipse 3239",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(3 3)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_273743",
    "data-name": "Group 273743",
    transform: "translate(6 2.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13513",
    "data-name": "Group 13513",
    transform: "translate(1.665 5.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11536",
    "data-name": "Group 11536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11212",
    "data-name": "Group 11212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21825",
    "data-name": "Path 21825",
    d: "M1098.513,254.8a4.5,4.5,0,0,1,9,0",
    transform: "translate(-1098.513 -245.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1742",
    "data-name": "Ellipse 1742",
    cx: 1.955,
    cy: 1.955,
    r: 1.955,
    transform: "translate(2.546)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForVerified);
export default __webpack_public_path__ + "static/media/forVerified.caf8ee45b0df2bcc4f984a1321022b54.svg";
export { ForwardRef as ReactComponent };